// extracted by mini-css-extract-plugin
export default {"table":"LevelsTable_table__LoCKa","total":"LevelsTable_total__bpNF+","projectCell":"LevelsTable_projectCell__QOvqg"};